import { NavLink } from 'react-router-dom'
import type { MouseEventHandler } from 'react'
import { Inbox, Mail, PenLine, Settings2, FileText } from 'lucide-react'
import './mail.css'

export function MailHeader({ title, description, onNavigate }: { title: string; description: string; onNavigate?: MouseEventHandler<HTMLAnchorElement> }) {
  return <header className="mail-header">
    <div className="mail-heading"><span className="mail-brand-icon"><Mail size={23} /></span>
      <div><h1>{title}</h1><p>{description}</p></div>
    </div>
    <nav aria-label="Navigazione posta" className="mail-tabs">
      <NavLink to="/mail/inbox" onClick={onNavigate}><Inbox size={16} />Posta</NavLink>
      <NavLink to="/mail/compose" onClick={onNavigate}><PenLine size={16} />Scrivi</NavLink>
      <NavLink to="/mail/drafts" onClick={onNavigate}><FileText size={16} />Bozze</NavLink>
      <NavLink to="/mail/accounts" onClick={onNavigate}><Settings2 size={16} />Caselle</NavLink>
    </nav>
  </header>
}
